import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/workspace/src/components/layout/client-providers.tsx");
